@if (mySuggestions$ | async; as mySuggestions) { @if (mySuggestions.length || acceptedNotification?.length || declinedNotification?.length) {
<div class="app__itemCard h-[320px]">
  <div class="connection-data-wrapper h-full">
    <div class="action__items-header mb-1">
      <div class="action__item-header-left">
        <h2 class="paragraph__medium m-0 text-[#1E1E20] text-[16px]">Network Suggestions</h2>
        <span class="ml-2">
          <!-- <div class="cursor-pointer"><help-button [step]="'Network Suggestions'"></help-button></div> -->
          <!-- <help-center-icon class="mt-[-1.3px]" [helpCenterLink]="helpCenterLink"> </help-center-icon> -->
        </span>
      </div>
      <button  
      class="absolute mr-2 mt-1 top-[8px] right-[10px] w-[32px] h-[32px] bg-[#EBF0FA] text-[#25508E] rounded-full flex items-center justify-center shadow-md  border border-[#7E9BD4]  "
      (click)="removeSuggestions(mySuggestionIds)" 
    >
      <span class="material-icons  text-lg">close</span>
    </button>
      <!-- <span class="material-icons  bg-[#EBF0FA] rounded-[50%] w-[24px] h-[22px] cursor-pointer"(click)="removeSuggestions(mySuggestionIds)" >close</span> -->
    </div>
    <div class="" [ngClass]="{ 'absolute pr-2 h-[90%]': mySuggestions.length >= 3, 'h-full': mySuggestions.length < 3 }">
      <div class="w-full overflow-y-auto h-[90%]" [ngClass]="{ 'pb-6': mySuggestions.length >= 3 }">
        @for (connection of mySuggestions; track connection; let i = $index) {
        <div class="h-fit" [ngClass]="{ 'mr-2': mySuggestions.length >= 3 }">
          <div class="action__item__request-container justify-start h-auto py-3 my-2">
            <div class="action__item__request-icone h-full">
              <ngx-avatars
                class="app__hideOnlyInMobil"
                size="83"
                src="{{ connection.profile_image_url }}"
                name="{{ connection.name | titlecase }}"
                [round]="false"
                cornerRadius="8"
                initialsSize="2"
              ></ngx-avatars>
              <ngx-avatars
                class="app__showOnlyInMobil"
                size="68"
                src="{{ connection.profile_image_url }}"
                name="{{ connection.name | titlecase }}"
                [round]="false"
                cornerRadius="8"
                initialsSize="2"
              ></ngx-avatars>
            </div>
            <div class="ml-3">
              <div class="action__item__request-info w-full">
                <h3 class="action__item__request--info--name m-0 mb-[2px]">
                  {{ connection.name | truncateStrPipe : 23 }}
                </h3>
                <h2
                  class="text-[#25508E] text-xs mb-[10px]"
                  style="text-decoration: underline; text-decoration-thickness: 0.5px; text-decoration-color: #25508e;cursor: pointer;"
                  (click)="mutualConnection(connection)"
                >
                  View Mutual Connections
                </h2>
              </div>
              <div class="action__item__request-btn gap-2 flex items-center w-11/12">
                <button class="app__btn--secondary--small m-0 px-[13.5px] py-2 hover:bg-[#EBF0FA]" (click)="removeSuggestions(connection)">Remove</button>
                <button
                  class="app__btn--primary--small m-0 px-[13.5px] py-2 sm:text-sm text-xxs"
                  [id]="'accept_' + connection.user_first_name"
                  (click)="acceptRequest({ connect_id: connection.connection_id, connect_status: 'approved' }, connection)"
                >
                  Connect
                </button>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>

} }
